import * as Yup from 'yup'
import { INTEREST_STATUS } from '../../redux-toolkits/interests/interests.constant'

export const INTEREST_NAME_MAX_LENGTH = 120
export const INTEREST_DESCRIPTION_MAX_LENGTH = 500

export const InterestFormSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .max(
      INTEREST_NAME_MAX_LENGTH,
      `Name must be ${INTEREST_NAME_MAX_LENGTH} characters or fewer`,
    )
    .required('Name is required'),
  description: Yup.string()
    .trim()
    .max(
      INTEREST_DESCRIPTION_MAX_LENGTH,
      `Description must be ${INTEREST_DESCRIPTION_MAX_LENGTH} characters or fewer`,
    ),
  status: Yup.string()
    .oneOf(
      [INTEREST_STATUS.ACTIVE, INTEREST_STATUS.DRAFT],
      'Choose a valid status',
    )
    .required('Status is required'),
  categories: Yup.array().required(),
})
